// Initialize the datadog RUM
export const initDataDogRUM = (datadogRum, initialState) => {
  if (initialState?.datadogRum?.applicationId) {
    const baseUrl = `https://${window.location.host}`;
    const trafficSource = initialState?.header?.userDetails?.trafficSourceInfo;
    let frameHost;
    if (window?.location !== window?.parent?.location) {
      frameHost = window?.document?.referrer;
    }

    datadogRum.init({
      ...initialState.datadogRum,
      version: window.DD_VERSION,
      proxy: (options) =>
        `${baseUrl}/analytics${options.path}?${options.parameters}`,
      allowedTracingUrls: [baseUrl]
    });

    window.DD_RUM?.setGlobalContextProperty("global", {
      affiliationId:
        initialState?.header?.userDetails?.affiliationId || "unknown",
      productCode: initialState?.productInfo?.productCode || "unknown",
      applicationCode: initialState?.productInfo?.applicationCode || "unknown",
      trafficSource,
      frameHost
    });
  }
};
